<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <!--      <span style="position: absolute; top:-70px; right:0px; z-index: 10000">-->
      <!--        <button-->
      <!--          ref="refresh"-->
      <!--          :disabled="isBusy"-->
      <!--          class="btn btn-light font-weight-bolder font-size-sm mx-1"-->
      <!--          @click="submitsearch"-->
      <!--        >-->
      <!--          <i class="flaticon2-refresh"></i>Refresh-->
      <!--        </button>-->
      <!--      </span>-->
      <div class="row">
        <div class="col-12">
          <div class="card card-custom gutter-b">
            <div class="card-header border-0 py-5">
              <h5>Transaction Summary Report</h5>
            </div>
            <div class="card-body pt-0 pb-3">
              <div class="row">
                <div class="col-6">
                  <b-form-group
                      label="From"
                      label-for="from"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="form.from"
                          v-mask="'####-##-##'"
                          :state="validateState('from')"
                          autocomplete="off"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="from"
                          placeholder="YYYY-MM-DD"
                          type="text"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.from"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                            button-only
                            class="button-only-datepicker"
                            locale="en-US"
                            name="date"
                            right
                        ></b-form-datepicker>
                      </b-input-group-append>
                      <b-form-invalid-feedback>
                        Date From is required.
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group
                      label="To"
                      label-for="to"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="form.to"
                          v-mask="'####-##-##'"
                          :state="validateState('to')"
                          autocomplete="off"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="to"
                          placeholder="YYYY-MM-DD"
                          type="text"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.to"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                            button-only
                            class="button-only-datepicker"
                            locale="en-US"
                            name="to"
                            right
                        ></b-form-datepicker>
                      </b-input-group-append>
                      <b-form-invalid-feedback>
                        Date To is required and must be greater than or equal to Date From.
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>

            </div>
            <div class="card-footer">
              <button
                  ref="submit"
                  :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
                  class="btn btn-primary mr-2"
                  type="button"
                  @click="submitViewPdf"
              >
                View PDF
              </button>
              <button
                  ref="submit"
                  :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
                  class="btn btn-secondary mr-2"
                  type="button"
                  @click="submitDownloadExcel"
              >
                Download Excel
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!--end::Row-->
  </div>
  <!--end::Container-->

</template>

<script>
import {mapGetters} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {mask} from "vue-the-mask";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import ApiService from "@/view/pages/easyreceipt/api";

export default {
  mixins: [validationMixin],
  components: {},
  directives: {mask},
  data() {
    return {
      isBusy: false,
      filters: {},
      options: {},
      form: {
        from: "",
        to: ""
      },
    };
  },
  validations: {
    form: {
      from: {required},
      to: {
        required,
        minValue(val, {from}) {
          return new Date(val) >= new Date(from);
        }//,
        // maxValue(val, {from}) {
        //   let day_from = new Date(from);
        //   var day_to = new Date(val);
        //   var difference = Math.abs(day_to - day_from);
        //   let days = difference / (1000 * 3600 * 24)
        //   return days <= 7;
        // }
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Transaction Summary Report");
      this.resetForm();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        },
        {
          title: "Reports",
          route: "/easyreceipt/adminreports"
        }];
      payload.push({title: value});
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        from: "",
        to: ""
      };
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    submitViewPdf() {
      //let url = `${ApiService.baseUrl}audit/export?StartDate=${this.form.from}&EndDate=${this.form.to}&Username=${this.form.username}&access_token=${ApiService.getToken()}`;
      let url = `https://${ApiService.getReportHost()}/reportserver/reportserver/httpauthexport?key=OMSMPC_Trx${ApiService.testEnvironmentReportsKeySuffix()}&p_RP_TransactionStartDate=${this.form.from}T00:00:00.000Z&p_RP_TransactionEndDate=${this.form.to}T00:00:00.000Z&user=EasyReceiptRO&apikey=79PKXGScP8r8&format=pdf&download=false`
      window.open(url, '_blank').focus();
    },
    submitDownloadExcel() {
      //let url = `${ApiService.baseUrl}audit/export?StartDate=${this.form.from}&EndDate=${this.form.to}&Username=${this.form.username}&access_token=${ApiService.getToken()}`;
      let url = `https://${ApiService.getReportHost()}/reportserver/reportserver/httpauthexport?key=OMSMPC_Trx${ApiService.testEnvironmentReportsKeySuffix()}&p_RP_TransactionStartDate=${this.form.from}T00:00:00.000Z&p_RP_TransactionEndDate=${this.form.to}T00:00:00.000Z&user=EasyReceiptRO&apikey=79PKXGScP8r8&format=excel&download=false`
      window.open(url, '_blank').focus();
    }
  },
  watch: {
    // currentPage(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //
    //   }
    // }
  }
};
</script>
